import { NumFixed } from "@/global/utils/num-fixed";
import EChartsReact from "echarts-for-react";
import { DatePicker } from "tncet-common";
import "./index.less"
import dayjs from "dayjs";
import { useEffect, useState } from "react";
interface IProps {
    // 表格名称（左上角）
    chartTitle?: string,
    // 表格额外信息（右上角）
    chartValue?: string,
    // 折线图数据
    lineData: number[][],
    // x轴名字
    xLabel?: string,
    // y轴名字
    yLabel?: string,
    // x轴值转换的方法
    getAxisXLabel?: (value: number) => string
    // y轴值转换方法
    getAxisYLabel?: (value: number) => string
    // 提示框x的标签
    toolTipXLabel?: string,
    // 提示框y的标签
    toolTipYLabel?: string,
    noBackground?: boolean,

    // 阈值线 从低到高
    tLine_1?: number,
    tLine_2?: number,
    tLine_3?: number,

    // 修改数据初始时间的方法
    onChangeEndTime?: (e) => void
}

export function LineChart(props: IProps) {

    const [endTime, setEndTime] = useState<number>(null)

    // 组织最后一个点的圈
    let lastPoint = props.lineData?.length > 0 ? [props.lineData[props.lineData.length - 1]] : null;
    let pointColor = "#1B7EF2"
    if (lastPoint != null && props.tLine_1 != null && lastPoint[0][1] > props.tLine_1) {
        pointColor = "#EC9C00";
    }
    if (lastPoint != null && props.tLine_2 != null && lastPoint[0][1] > props.tLine_2) {
        pointColor = "#F26600";
    }
    if (lastPoint != null && props.tLine_3 != null && lastPoint[0][1] > props.tLine_3) {
        pointColor = "#F21B1B";
    }

    useEffect(() => {
        // 获取最后一个时间
        let firstTime
        if (props.lineData?.length > 0) {
            firstTime = (props.lineData[props.lineData.length - 1][0])
        } else {
            firstTime = (Date.now())
        }
        setEndTime(firstTime)
    }, [props.lineData])



    const xAxisRange = 0.9;

    const options = {
        backgroundColor: 'rgba(1, 1, 1, 0)',
        title: {
            text: props?.chartTitle || "",
            left: "left",
            textStyle: {
                fontSize: "18px",
                color: "#0C51C8",
                fontWeight: 400,
            },
            backgroundColor: "#fff",
            padding: props?.chartTitle ? [8, 10, 4, 10] : 0,
            borderRadius: [8, 0, 0, 0]
        },
        tooltip: {
            trigger: "axis",
            formatter: function (params) {
                if (params[0]?.data?.length <= 0) return '';
                const date: number = params[0]?.data[0]; // x 轴的值
                let xValue = date.toString()
                if (props?.getAxisXLabel) {
                    xValue = props.getAxisXLabel(date)
                }
                let res = ''
                const value = params[0].data[1]; // y 轴的值
                let yValue = value.toString()
                if (props?.getAxisYLabel) {
                    yValue = props.getAxisYLabel(value)
                }
                res = `${(props?.toolTipXLabel ? props.toolTipXLabel : "X")}: ${xValue}${props?.xLabel ? props?.xLabel : ""}
                        <br/>
                        ${(props?.toolTipYLabel ? props.toolTipYLabel : "Y")}: ${yValue}${props?.yLabel ? props?.yLabel : ""}`
                return res;
            }
        },
        xAxis: {
            type: 'category',
            name: props?.xLabel || "x",
            nameLocation: "end",
            nameGap: 10,
            nameTextStyle: {
                fontSize: "12px",
                fontWeight: 400,
                verticalAlign: 'top',
                color: "#568AE5"
            },
            max: function (value) {
                return NumFixed((value.max / xAxisRange), 0);
            },
            axisLine: {
                lineStyle: {
                    color: '#005DFF', // X轴颜色
                    width: 3,
                },
                symbol: ['none', 'arrow'], // 在X轴的正方向上添加箭头
                symbolSize: [12, 15], // 箭头大小
                symbolOffset: [0, 10]
            },
            axisLabel: {
                color: '#568AE5', // X轴标签颜色
                formatter: function (value, index) {
                    // 将时间戳转换为日期字符串
                    // if (value === undefined || value === null || value === '') {
                    //     return '';  // 返回空字符串或其他默认值
                    // }
                    if (props.lineData?.length <= 0) return '';
                    if (index >= props.lineData?.length) {
                        // 计算最大时间戳
                        let maxTimestamp = props.lineData[props.lineData?.length - 1][0];
                        let startIdx = props.lineData?.length - 2;
                        if (startIdx < 0) startIdx = 0;
                        let minTimestamp = props.lineData[startIdx][0];
                        let deltaRange = maxTimestamp - minTimestamp;
                        let timeRange = deltaRange * (props.lineData?.length);
                        value = maxTimestamp + timeRange * (1 - xAxisRange);
                    }
                    if (props.getAxisXLabel) {
                        return props.getAxisXLabel(value)
                    } else {
                        return value
                    }
                },
            },
            axisTick: {
                alignWithLabel: true, // 使刻度线与标签对齐
            },
        },
        yAxis: {
            type: 'value',
            name: props?.yLabel || "y",
            nameLocation: "end",
            nameGap: 20,
            nameTextStyle: {
                fontSize: "12px",
                fontWeight: 400,
                verticalAlign: 'top',
                color: "#568AE5"
            },
            // max: function (value) {
            //     // console.log("y max", value)
            //     return (value.max * 1.2).toFixed(2);
            // },
            axisLine: {
                show: true,
                lineStyle: {
                    color: '#005DFF', // Y轴颜色
                    width: 3
                },
                symbol: ['none', 'arrow'], // 在Y轴的正方向上添加箭头
                symbolSize: [12, 15], // 箭头大小
                symbolOffset: [0, 10]
            },
            axisLabel: {
                color: '#568AE5', // Y轴标签颜色
                formatter: function (value, index) {
                    // 将时间戳转换为日期字符串
                    // if (value === undefined || value === null || value === '') {
                    //     return '';  // 对占位符不进行显示
                    // }

                    if (props.getAxisYLabel) {
                        return props.getAxisYLabel(value)
                    } else {
                        return value
                    }
                },
            },
            splitLine: {
                lineStyle: {
                    color: '#D4E1F6', // Y轴网格线颜色
                    width: 1,
                    type: "dashed"
                },
                interval: 1
            },
            axisTick: {
                alignWithLabel: true, // 使刻度线与标签对齐
            },
        },
        grid: {
            left: '3%',   // 调整左边距
            right: '8%',  // 调整右边距
            top: '25%',   // 调整上边距
            bottom: '0%', // 调整下边距
            containLabel: true  // 防止标签溢出容器
        },
        series: [
            {
                data: props.lineData,
                type: 'line',
                smooth: false,
                lineStyle: {
                    color: '#1B7EF2', // 折线颜色
                    width: 2, // 折线宽度
                },
                showSymbol: false, // 隐藏数据点
                emphasis: {
                    focus: 'series',
                    itemStyle: {
                        color: '#1B7EF2', // 鼠标悬停时数据点的颜色
                    },
                },
                markLine: {
                    symbol: "none",
                    data: [
                        {
                            slient: false,
                            lineStyle: {
                                type: "dashed",
                                color: !props?.tLine_1 ? "#005DFF" : "#EC9C00",
                                width: 2
                            },
                            yAxis: props?.tLine_1 || 0,
                            label: {
                                show: false
                            }
                        },
                        {
                            slient: false,
                            lineStyle: {
                                type: "dashed",
                                color: !props?.tLine_2 ? "#005DFF" : "#F26600",
                                width: 2
                            },
                            yAxis: props?.tLine_2 || 0,
                            label: {
                                show: false
                            }
                        },
                        {
                            slient: false,
                            lineStyle: {
                                type: "dashed",
                                color: !props?.tLine_3 ? "#005DFF" : "#F21B1B",
                                width: 2
                            },
                            yAxis: props?.tLine_3 || 0,
                            label: {
                                show: false
                            }
                        }
                    ]
                }
            },
            {
                data: props.lineData?.length > 0 && [props.lineData[props.lineData.length - 1]],
                type: 'scatter',
                symbol: 'circle', // 设置点的形状为圆形
                symbolSize: 8, // 设置点的大小
                itemStyle: {
                    color: pointColor, // 设置填充色
                    borderColor: pointColor, // 设置边框颜色
                    borderWidth: 3 // 设置边框宽度
                }
            },
        ],
        graphic: [
            {
                type: "text",
                right: "4%",
                top: "4%",
                style: {
                    text: props?.chartValue || "",
                    fontSize: "16px",
                    fontWeight: 400,
                    fill: "#626262",
                },
            },
        ]
    }

    return (
        <div className="tncet-echart">
            <EChartsReact

                style={{
                    // background: "linear-gradient(180deg, #E0ECFF 0%, #FFF 100%)",
                    background: `${props?.noBackground ? "" : "linear-gradient(180deg, #E0ECFF 0%, #FFF 100%)"}`,
                    width: "100%",
                    height: "100%",
                    borderRadius: "8px"
                }}
                option={options}
            />
            {props?.onChangeEndTime && (
                <div className="date-pick">
                    <DatePicker
                        allowClear={false}
                        showTime={{ minuteStep: 1, showHour: true, showMinute: true, showSecond: true }}
                        format="YYYY-MM-DD HH:mm:ss"
                        showNow={false}
                        onChange={(e) => {
                            setEndTime(e.valueOf())
                            props.onChangeEndTime(e.valueOf())
                        }}
                        value={dayjs(endTime || Date.now())}
                    />
                </div>
            )}

        </div>
    )
}